define('constants/verificationQuestionConstants',[], function() {
    return {
        city_mother_and_father_met : 1,
        sixth_grade_school: 2,
        first_pet: 3,
        nickname: 4,
        high_school_mascot: 5
    };
});
